













































































































import Vue from 'vue'
import { Component, Ref } from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {notifySuccess, notifyError, notifyConfirm} from "@/utils/notify-helper";
import {cloneDeep, isEqual} from "lodash";
import {FormRowWings} from '@/components';

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: { FormRowWings }})
export default class UserProfile extends Vue {
  @Ref('validator') validator:any;

  @Getter("isADUser") isADUser!: boolean;

  @Action("getTimeZones") actionGetTimeZones: any;
  @Action("getProfile") actionGetItem: any;
  @Action("saveProfile") actionSaveItem: any;
  @Action("changePassword") actionChangePassword: any;
  @Action("authLogout") authLogout: any;

  private item: any =  {
    email: null,
    name: null,
    msisdn: null,
    company: null,
    timeZone: {
      id: null,
      name: null,
    },
  };
  private userPassword: any = {
    newPassword: null,
    newPasswordAgain: null,
  }
  private itemSaved: any;
  private userPasswordSaved: any;
  private timezones: string[] = [];

  async created() {
    try {
      let res = await this.actionGetTimeZones();
      this.timezones = res.data

      res = await this.actionGetItem();

      this.item = Object.assign({}, this.item, res.data);
      this.itemSaved = cloneDeep(this.item);
      this.userPasswordSaved = cloneDeep(this.userPassword)
    } catch(error) {
      notifyError(error);
    }
  }

  onSaveItem(): Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        await this.actionSaveItem({...this.item, timeZone: this.item.timeZone.name});
        this.itemSaved = cloneDeep(this.item);
        if (this.userPassword.newPassword) {
          await this.actionChangePassword(this.userPassword);
          await this.authLogout();
          this.$router.push("/login");
        }
        resolve();
      } catch (err) {
        reject();
        notifyError(err);
      }
    });
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item, this.itemSaved) || !isEqual(this.userPassword, this.userPasswordSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

};
